<template>
  <div class="vb-quote-view">
    <b-container>
      <section v-if="loading" class="section section--loader">
        <loader size="large" :show_timing_slot="true" />
      </section>
      <section v-else class="section">
        <quote :quote="quote" />
      </section>
    </b-container>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';

  import { alpitour_service_handler } from '@alpitour/services/common';
  import { alpitour_rybbit_event } from '@alpitour/utilities/rybbit';
  import { normalize_check_to_quote } from '@alpitour/utilities/quote-normalize';
  import Quote from '@alpitour/components/views/content-blocks/quote/quote.vue';

  export default {
    name: 'quote-view',
    components: {
      quote: Quote,
    },
    data() {
      return {
        loading: true,
      };
    },
    computed: {
      // global state keys
      ...mapState(['searching']),
      // module state keys
      ...mapState('liveat', [
        'last_search',
        'current_search',
        'selected_room',
        'quote',
      ]),
      ...mapGetters('liveat', ['is_only_stay_package']),
    },
    mounted() {
      alpitour_rybbit_event('quote:page:view');
      this.get_quote();
    },
    methods: {
      get_quote() {
        const { quote_payload } = this.selected_room;

        alpitour_service_handler(
          'quote', 
          quote_payload, 
          {
            track: { 
              name: 'quote', 
              phase: 'load' 
            } 
          }
        ).then((success) => {
          this.log('[quote.vue] - success');
          this.log(success.data);

          const { data } = success.data;
          const { solution } = this.selected_room || {};
          const { dateFrom = '', dateTo = '' } = solution || {};

          const quote = this.is_only_stay_package
            ? normalize_check_to_quote(data, this.$store.state.occupancy, {
                checkin: dateFrom,
                checkout: dateTo,
              })
            : data;

          if (!quote || Object.keys(quote).length === 0) {
            this.log('[quote.vue] - empty quote');
            alpitour_rybbit_event('quote:load:empty');
            this.$store.commit('liveat/quote', {});
            window.eventBus.$emit('got_modal_notification', {
              msg: 'Si è verificato un errore durante il caricamento del preventivo. Torna alla ricerca e riprova.',
              routerPush: 'results',
            });
            return;
          }
          this.$store.commit('liveat/quote', quote);
          this.loading = false;
        });
      }
    },
  };
</script>
